import { ParamethorEnum } from '@repo/common/enums';

// Fallback values if paramethor service is unreachable, most suited for France
export const paramethorFallbackValues: Partial<
  Record<ParamethorEnum, string | null>
> = {
  [ParamethorEnum.BACK_OFFICE_WIDGET]: 'false',
  [ParamethorEnum.BACK_OFFICE_CIS]: 'false',
  [ParamethorEnum.BACK_OFFICE_CALENDAR_ANIMATIONS]: 'true',
  [ParamethorEnum.BACK_OFFICE_SCHEDULE_AVAILABILITY]: 'true',
  [ParamethorEnum.BACK_OFFICE_SCHEDULE_UNAVAILABILITY]: 'true',
  [ParamethorEnum.BACK_OFFICE_SCHEDULE_ASSOCIATED_SERVICES]: 'true',
  [ParamethorEnum.BACK_OFFICE_SERVICE_DETAILS]: 'true',
  [ParamethorEnum.BACK_OFFICE_SERVICE_DETAILS_MINIMAL_DELAY]: 'true',
  [ParamethorEnum.BACK_OFFICE_SERVICE_DETAILS_START_TIME_INTERVAL]: 'true',
  [ParamethorEnum.BACK_OFFICE_SERVICE_AVAILABILITY]: 'true',
  [ParamethorEnum.BACK_OFFICE_CUSTOM_COUNTRY_SERVICES]: null,
  [ParamethorEnum.BACK_OFFICE_CREATE_PANEL]: 'true',
  [ParamethorEnum.BACK_OFFICE_EDIT_APPOINTMENT]: 'true',
  [ParamethorEnum.BACK_OFFICE_SWITCH_CONTEXT]: 'false',
  [ParamethorEnum.WIDGET_TERMS_AND_CONDITIONS]: '{}',
  [ParamethorEnum.WIDGET_HELP_SECTION]: 'false',
  [ParamethorEnum.WIDGET_WHATS_NEXT_SECTION]: 'true',
  [ParamethorEnum.WIDGET_HOME_PAGE]: 'false',
  [ParamethorEnum.WIDGET_SEARCHABLE_STORE_LIST]: 'false',
  [ParamethorEnum.WIDGET_HIDE_TEST_E_BIKE]: 'false',
  [ParamethorEnum.PRODUCT_SHEETS_SORTING]: '[]',
  [ParamethorEnum.WIDGET_REQUEST_PHONE_NUMBER]: 'false',
  [ParamethorEnum.WIDGET_REQUEST_ORDER_NUMBER]: 'false',
  [ParamethorEnum.WIDGET_REQUEST_LEASING_NUMBER]: 'false',
  [ParamethorEnum.WIDGET_HIDE_SERVICES]: '[]',
  [ParamethorEnum.WIDGET_DIDOMI_CONSENT]: 'false',
  [ParamethorEnum.WIDGET_HIDE_SERVICE_PRICES]: '[]',
  [ParamethorEnum.WIDGET_DISPLAY_REDIRECT_BANNER]: 'false',
  [ParamethorEnum.WIDGET_DISPLAY_REDIRECT_BANNER_CH]: 'false',
};
